/**
 * Bind event action from one element to another
*/

import jQuery from 'jquery'

jQuery(document).on('click', '.bind-click-to-elem', (event) => {
    
    event.preventDefault()
    
    let
        clicked = jQuery(event.currentTarget),
        target = clicked.data('target'),
        action = clicked.data('action'),
        elem = jQuery(target)
    
    if (elem.length === 0 || elem[0] == event.target) {
        return
    }
    
    elem.trigger(action ? action : 'click')
    
})